import { render, staticRenderFns } from "./ZumiStamp.vue?vue&type=template&id=374e8278&"
import script from "./ZumiStamp.vue?vue&type=script&lang=js&"
export * from "./ZumiStamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports